import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const nextGenBoardEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-next-gen-board-entrypoint" */ './src/index.tsx'),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: () => {
		return {};
	},
});
